export const LEGACY_API_V1_PATTERNS = [
  /\/v1\/routes\/company-workers/,
  /\/v1\/routes\/manage-jobs-v2/,
  /\/v1\/companies\/\d+\/workers/,
  /\/v1\/users\/\d+\/retrieveI9Docs/,
  /\/v1\/job\/increaseWage/,
  /\/v1\/routes\/manage-jobs/,
];